@import "../../../globals/bcp-2022/old-mixins/traffic-lights";

:host {
  @include traffic-lights();
  max-width: 8.75rem;
  display: flex;
}
